import React, { useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpIcon } from 'lucide-react';
import { FormSection, TextField, SelectField, TextAreaField, DisplayField } from '../components/FormComponents';
import { mockProducts, masterDataSets } from '../data/mockData';
export function StockOutForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    product: '',
    productCode: '',
    warehouse: '',
    quantity: '',
    unitOfMeasure: '',
    remarks: ''
  });
  const handleProductChange = (productId: string) => {
    const selectedProduct = mockProducts.find(p => p.id === productId);
    if (selectedProduct) {
      setFormData(prev => ({
        ...prev,
        product: productId,
        productCode: selectedProduct.productCode,
        unitOfMeasure: selectedProduct.unitOfMeasure,
        warehouse: selectedProduct.warehouse || prev.warehouse
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        product: '',
        productCode: '',
        unitOfMeasure: ''
      }));
    }
  };
  const handleSubmit = () => {
    alert('Loss recorded successfully!');
    navigate('/stock');
  };
  const warehouseOptions = [...(masterDataSets.warehouses || []).filter(wh => wh.status === 'Active').map(wh => ({
    value: wh.name,
    label: `${wh.name} (${wh.code})`
  }))];
  const productOptions = mockProducts.map(p => ({
    value: p.id,
    label: `${p.productName} (${p.productCode})`
  }));
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-2528">
      <div className="flex items-center gap-3" data-id="element-2529">
        <div className="p-3 bg-red-100 rounded-lg" data-id="element-2530">
          <ArrowUpIcon className="h-6 w-6 text-red-600" data-id="element-2531" />
        </div>
        <div data-id="element-2532">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2533">Loss</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-2534">
            Remove inventory from a warehouse — select a product, warehouse, and
            quantity.
          </p>
        </div>
      </div>

      <form className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8" data-id="element-2535">
        <FormSection title="Loss Details" data-id="element-2536">
          <TextField label="Date" type="date" value={formData.date} onChange={e => setFormData({
          ...formData,
          date: e.target.value
        })} required data-id="element-2537" />
          <SelectField label="Product" value={formData.product} onChange={e => handleProductChange(e.target.value)} options={productOptions} required data-id="element-2538" />
          <DisplayField label="Product Code" value={formData.productCode || '—'} data-id="element-2539" />
          <SelectField label="Warehouse" value={formData.warehouse} onChange={e => setFormData({
          ...formData,
          warehouse: e.target.value
        })} options={warehouseOptions} required data-id="element-2540" />
          <TextField label="Quantity" type="number" min="1" value={formData.quantity} onChange={e => setFormData({
          ...formData,
          quantity: e.target.value
        })} required data-id="element-2541" />
          <DisplayField label="Unit of Measure" value={formData.unitOfMeasure || '—'} data-id="element-2542" />
        </FormSection>

        <FormSection title="Additional Information" data-id="element-2543">
          <TextAreaField label="Remarks" value={formData.remarks} onChange={e => setFormData({
          ...formData,
          remarks: e.target.value
        })} rows={3} placeholder="Reason for removing stock..." data-id="element-2544" />
        </FormSection>

        <div className="mt-8 pt-5 border-t border-gray-200 flex justify-end space-x-3" data-id="element-2545">
          <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-2546">
            Cancel
          </button>
          <button type="button" onClick={handleSubmit} className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700" data-id="element-2547">
            Submit Loss
          </button>
        </div>
      </form>
    </div>;
}